import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check_oval",
  "use": "icon-check_oval-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 13 13\" id=\"icon-check_oval\">\n    <circle cx=\"6.5\" cy=\"6.5\" r=\"6.5\" fill=\"#009CE5\" />\n    <path stroke=\"#fff\" stroke-width=\"1.543\" d=\"M3 6.623L5.118 9 9 4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol